// @ts-check
/* global module require */
'use_strict';

/**
 * Class to manage the UI for the YOTPO Badge in the Header.
 */
export class YOTPOBadge {

    /**
     * @var {HTMLDivElement} wrapper is the first wrapper in the YOTPO Badge before we get to the pieces.
     * @var {HTMLImageElement} image is the badge image used for the background.
     * @var {HTMLDivElement} numbers is the Div that contains the Number of Reviews.
     * @var {HTMLDivElement} certified is the Certified Reviews label for the Badge Ribbon.
     * @var {HTMLSpanElement} stars is the Span element that contains the Stars Rating.
     * @var {HTMLDivElement} powered_by is the Powered By YOTPO label.
     * @var {HTMLDivElement} left_div is a Div for the left side of the Header Badge.
     * @var {HTMLDivElement} right_div is a Div for the right side of the Header Badge.
     */
    wrapper: HTMLDivElement;
    image: HTMLImageElement;
    numbers: HTMLDivElement;
    certified: HTMLDivElement;
    stars: HTMLSpanElement;
    powered_by: HTMLDivElement;
    left_div: HTMLDivElement;
    right_div: HTMLDivElement;

    /**
     * Fetches all the pieces and initializes the changes we need.
     *
     * @param {HTMLDivElement} badge is the Badge we are going to Change.
     */
    constructor(badge: HTMLDivElement) {
        if (badge.childElementCount) {
            this.wrapper = badge.querySelector('.y-badge');
            this.image = badge.querySelector('.y-badge-image');
            this.numbers = badge.querySelector('.y-badge-reviews');
            this.certified = badge.querySelector('.y-badges-certified');
            this.stars = badge.querySelector('.y-badge-stars');
            this.powered_by = badge.querySelector('.y-powered-by');

            this.initialize();
        }
    }

    /**
     * Method to initialize the left and right side of the Badge and put it all together.
     *
     * @return {void}.
     */
    initialize() : void {
        this.left_div = this.create_parent_with_children('left', this.image, this.numbers, this.certified);
        this.right_div = this.create_parent_with_children('right', this.stars, this.powered_by);
        this.wrapper.appendChild(this.left_div);
        this.wrapper.appendChild(this.right_div);
    }

    /**
     * Method to create a div with an appropriate class and append many children.
     *
     * @param {string} label is the designation label, such as 'left' or 'right'.
     * @param {...HTMLElement[]} children is an array of children needing to be added to the returned Div.
     *
     * @return {HTMLDivElement} is the Div element created with the children and class label.
     */
    create_parent_with_children(label: string, ...children: HTMLElement[]) : HTMLDivElement {
        const parent = document.createElement('div');
        parent.classList.add(`y-badge-${label}`);
        for(const key in children) {
            parent.appendChild(children[key]);
        }
        return parent;
    }

}